import { ReportMetadata } from '../../types';
import { getRepresentatives, istPlanungsVerantwortlicher } from '../../services/projectRepresentatives';
import { PlanVerantwortlicher } from './types';

/**
 * Verantwortliche des SiGe-Plan-Plankopfs aus den Projekt-Stammdaten.
 *
 * `getRepresentatives` ist die Wahrheitsquelle (Index 0 = Koordinator) und löst
 * auch Alt-Projekte ohne `representatives`-Array auf.
 *
 * Eine Verantwortliche Planungsphase (docs/projekt-kickoff-plan.md §5) steht
 * als „SiGeKo Planung" im Plankopf, nicht als „Vertretung": Der SiGe-Plan ist
 * ein Dokument der Planungsphase, und genau dafür ist sie bestellt. Als
 * Vertretung gedruckt behauptete der Plan, sie vertrete den Koordinator auf der
 * Baustelle — das tut sie nicht. Die Rolle steht wörtlich im Plankopf.
 */
export const plankopfVerantwortlicheAusProjekt = (
    meta: ReportMetadata | undefined | null,
): PlanVerantwortlicher[] =>
    getRepresentatives(meta).map((r, i) => ({
        name: r.name,
        rolle: i === 0 ? 'SiGeKo' : istPlanungsVerantwortlicher(r) ? 'SiGeKo Planung' : 'Vertretung',
        telefon: r.phone || undefined,
        email: r.email || undefined,
    }));
